import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { ResponsiveService } from 'src/app/services/responsive/responsive.service';
import { BaseComponent } from 'src/app/shared/components/base-component';

@Component({
  selector: 'app-popup-request-mail-description',
  templateUrl: './popup-request-mail-description.component.html',
  styleUrls: ['./popup-request-mail-description.component.scss'],
})
export class PopupRequestMailDescriptionComponent
  extends BaseComponent
  implements OnInit
{
  constructor(
    public override responsive: ResponsiveService,
    public override transloco: TranslocoService
  ) {
    super(responsive, transloco);
  }

  ngOnInit(): void {}
}
